
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whalar/signup",
      function () {
        return require("private-next-pages/whalar/signup/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whalar/signup"])
      });
    }
  